const H2Cont = (props) => {
    return ( 
        <h2 className="relative text-xl">
            {props.children}
        </h2>
     );
}
 
export default H2Cont;